document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.wf-block table').forEach((elem) => {
    if (!elem.closest('.table-responsive')) {
      let wrap = document.createElement('div');
      wrap.classList.add('table-responsive');
      elem.parentElement.insertBefore(wrap, elem);
      wrap.appendChild(elem);
    }
  })
})